import { routes } from "@/constants/routes";
import { Redirect } from "expo-router";

/** Die Mandanten-Konfiguration gibt es nicht mehr. */
export default function ConfigHubRedirect() {
  return <Redirect href={routes.home} />;
}
